<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-12">
          <div class="element-wrapper">
            <div class="element-box">
              <form @submit="guardar">
                <h5 v-if="!current.id" class="form-header">Nuevo Listado de Centros de Costos</h5>
                <div v-if="!current.id" class="form-desc">Adición de nueva lista</div>
                <h5 v-if="current.id" class="form-header">Edición de Centro Costo</h5>

                <div class="row">
                  <div class="col-lg-3 col-sm-12 col-md-12">
                    <div class="form-group">
                      <label
                        v-bind:class="{ 'text-danger': current.errors.id && current.errors.id.length > 0 }"
                      >Código</label>
                      <input
                        v-model="current.id"
                        class="form-control"
                        autofocus="autofocus"
                        :readonly="current._id != null"
                        placeholder="Código"
                        type="text"
                        v-bind:class="{ 'is-invalid': current.errors.id && current.errors.id.length > 0 }"
                      />
                      <small
                        v-if="current.errors && current.errors.id"
                        class="form-text text-danger"
                      >{{ current.errors.id[0] }}</small>
                    </div>
                  </div>
                  <div class="col-lg-9 col-sm-12 col-md-12">
                    <div class="form-group">
                      <label
                        v-bind:class="{ 'text-danger': current.errors.nombre && current.errors.nombre.length > 0 }"
                      >Nombre de Centro de Costos</label>
                      <input
                        v-model="current.nombre"
                        class="form-control"
                        placeholder="Nombre"
                        v-bind:class="{ 'is-invalid': current.errors.nombre && current.errors.nombre.length > 0 }"
                        type="text"
                      />
                      <small
                        v-if="current.errors && current.errors.nombre"
                        class="form-text text-danger"
                      >{{ current.errors.nombre[0] }}</small>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-3">
                    <div class="form-check">
                      <label class="form-check-label">
                        <input
                          class="form-check-input"
                          name="optionsRadios"
                          v-model="current.activa"
                          type="radio"
                          value="true"
                        />Activa
                      </label>
                    </div>
                    <div class="form-check">
                      <label class="form-check-label">
                        <input
                          class="form-check-input"
                          v-model="current.activa"
                          name="optionsRadios"
                          type="radio"
                          value="false"
                        />Inactiva
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-check">
                      <label class="form-check-label">
                        <input
                          checked
                          class="form-check-input"
                          name="optionsRadiosPermitirTraslados"
                          v-model="current.permite_traslados"
                          type="radio"
                          value="true"
                        />Permite Traslados
                      </label>
                    </div>
                    <div class="form-check">
                      <label class="form-check-label">
                        <input
                          class="form-check-input"
                          v-model="current.permite_traslados"
                          name="optionsRadiosPermitirTraslados"
                          type="radio"
                          value="false"
                        />No Permite traslados
                      </label>
                    </div>
                  </div>
                </div>

                <div class="form-buttons-w">
                  <button class="btn btn-primary" type="submit">Guardar</button>
                  <router-link
                    class="btn btn-default"
                    :to="{ name: 'cat-centro-costos', params: {  }}"
                  >
                    <i class="fa fa-back"></i>
                    Volver al Listado
                  </router-link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import PaginationComponent from "@/components/utils/PaginationComponent";
import CentroCostoService from "@/services/catalogos/CentroCostoService";
import Notifications from "@/notifications/notifications";

export default {
  data() {
    return {
      current: {
        errors: {}
      },
      data: []
    };
  },

  computed: {},
  mounted() {
    let self = this;
    if (self.$route.params.id) {
      CentroCostoService.getById(self.$route.params.id).then(response => {
        self.current = response.data;
        self.current.id = self.$route.params.id;
        self.current._id = self.$route.params.id;
        self.current.errors = [];
      });
      self.refreshData();
    }
  },

  methods: {
    guardar(e) {
      let self = this;
      e.preventDefault();
      var current = Object.assign({}, this.current);
      delete current.image;
      if (this.$route.params.id) {
        current.pk = this.$route.params.id;
        delete current.id;
      }
      CentroCostoService.save(current)
        .then(res => {
          self.current = res.data;
          self.current.errors = {};
          Notifications.alert.success(
            "Lista",
            "Se ha guardado la Información."
          );
          self.$router.push({
            name: "cat-centro-costos",
            params: { id: self.current.id }
          });
        })
        .catch(error => {
          if (error.response) {
            console.log(error.response);
            self.current.errors = error.response.data;
          }
        });
    },
    showModal(e) {
      e.preventDefault();
    },

    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.searchtext,
        activa: this.filterActivo
      });
    },
    filterData() {
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        activa: this.filterActivo
      });
    },
    clearFilterData() {
      this.searchtext = "";
      this.filterActivo = null;
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        activa: this.filterActivo
      });
    },
    hide: function() {
      this.$data.destroy();
    },
    onRefreshData() {},
    refreshData(params) {
      let self = this;
    }
  }
};
</script>
